import pointer from '../../images/cursors/hover_cursor.png';
import idle from '../../images/cursors/idle_cursor.png';
import communication from '../../images/cursors/kommunikation_hover.png';
import computer from '../../images/cursors/webb_hover.png';
import graphics from '../../images/cursors/rorligt_cover.png';
import glasses from '../../images/cursors/more_cool_cases.png';
import hourglass from '../../images/cursors/load_more_case.png';
import play from '../../images/cursors/play_video.png';
import pause from '../../images/cursors/pause_video.png';

export const breakpoints = ['52em', '64em', '80em', '100em'];

export const mq = {
	small: `@media screen and (min-width: ${breakpoints[0]})`,
	medium: `@media screen and (min-width: ${breakpoints[1]})`,
	large: `@media screen and (min-width: ${breakpoints[2]})`,
	xlarge: `@media screen and (min-width: ${breakpoints[3]})`,
	xxlarge: `@media screen and (min-width: ${breakpoints[4]})`
};

const grid = {
	gridMaxWidth: '1106px',
	gridMaxWidthLarge: '1400px'
};

export const sizes = {
	headerHeight: '5rem'
};

const cursor = {
	pointer: `url(${pointer}) 15 0, auto`,
	pointerWhite: `url(${pointer}) 30 0, auto`,
	hourglass: `url(${hourglass}), auto`,
	glasses: `url(${glasses}), auto`,
	idle: `url(${idle}), auto`,
	communication: `url(${communication}) 15 0, auto`,
	computer: `url(${computer}) 30 0, auto`,
	graphics: `url(${graphics}), auto`,
	play: `url(${play}), auto`,
	pause: `url(${pause}), auto`
};

const fontSizes = {
	p: '20px',
	pLarge: '28px',
	h1Large: '4.33rem',
	h1: '3.33rem',
	h1Small: '2.9rem',
	h2: '2.77rem',
	h3: '2.3rem',
	h4: '1.5rem',
	h5: '1.55rem',
	h6: '1rem',
	pSmall: '16px'
};

const gridSettings = {
	gridTemplateAreas: [
		'',
		`"i1 i1 i1 i2 i2 i2"
		"i3 i3 i4 i4 i5 i5"
		"i6 i6 i6 i8 i8 i8"
		"i7 i7 i7 i8 i8 i8"`
	],
	gridTemplateColumns: ['1fr', `repeat(6, 1fr)`],
	gridTemplateRows: `repeat(auto-fill, 1fr)`,
	default: 'span 2',
	aspectRatios: {
		i6: 1 / 2,
		i7: 1 / 2
	}
};

const space = {
	0: 0,
	1: 4,
	2: 8,
	3: 16,
	4: 32,
	5: 64,
	6: 78,
	7: 128,
	8: 256,
	headerHeight: '5rem'
};

const fontWeights = {
	regular: 400,
	bold: 900
};

const textTransforms = {
	uppercase: 'uppercase',
	lowercase: 'lowercase'
};

const fonts = {
	headlines: 'CircularStd, Akkurat Pro, Helvetica',
	serif: 'athelas, georgia, times, serif',
	sansSerif: 'Akkurat Pro, arial, sans-serif'
};

const borders = [0, '1px solid', '2px solid', '4px solid', '8px solid', '16px solid', '32px solid'];

const lineHeights = {
	solid: 1,
	title: 1.25,
	copy: 1.5
};

export const colors = {
	client: {
		primary: '#2300E6',
		primaryOpacity: 'rgb(35 0 230 / 90%)',
		accent: '#FFE3E3',
		accentDark: '#FF9AA5',
		fontColor: '#07002F',
		darkBlue: '#07002F'
	},
	black: '#000',
	'near-black': '#111',
	'dark-gray': '#333',
	'mid-gray': '#555',
	gray: ' #777',
	silver: '#999',
	'light-silver': '#aaa',
	'moon-gray': '#ccc',
	'light-gray': '#eee',
	'near-white': '#f4f4f4',
	white: '#fff',
	transparent: 'transparent',
	blacks: [
		'rgba(0,0,0,.0125)',
		'rgba(0,0,0,.025)',
		'rgba(0,0,0,.05)',
		'rgba(0,0,0,.1)',
		'rgba(0,0,0,.2)',
		'rgba(0,0,0,.3)',
		'rgba(0,0,0,.4)',
		'rgba(0,0,0,.5)',
		'rgba(0,0,0,.6)',
		'rgba(0,0,0,.7)',
		'rgba(0,0,0,.8)',
		'rgba(0,0,0,.9)'
	],
	whites: [
		'rgba(255,255,255,.0125)',
		'rgba(255,255,255,.025)',
		'rgba(255,255,255,.05)',
		'rgba(255,255,255,.1)',
		'rgba(255,255,255,.2)',
		'rgba(255,255,255,.3)',
		'rgba(255,255,255,.4)',
		'rgba(255,255,255,.5)',
		'rgba(255,255,255,.6)',
		'rgba(255,255,255,.7)',
		'rgba(255,255,255,.8)',
		'rgba(255,255,255,.9)'
	]
};

const theme = {
	grid,
	fontSizes,
	fonts,
	borders,
	lineHeights,
	fontWeights,
	space,
	colors,
	textTransforms,
	sizes,
	gridSettings,
	cursor
	// breakpoints
};

export default theme;
